import { render, staticRenderFns } from "./salaryDetails.vue?vue&type=template&id=c2b29d80&scoped=true"
import script from "./salaryDetails.vue?vue&type=script&lang=js"
export * from "./salaryDetails.vue?vue&type=script&lang=js"
import style0 from "./salaryDetails.vue?vue&type=style&index=0&id=c2b29d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b29d80",
  null
  
)

export default component.exports